import React from "react";
import LoginView from './LoginView';

const LoginViewController = () => {
    return <LoginView />
}

export default LoginViewController;